import BankAccountService from '@/services/retailer/BankAccountService.js'

export const namespaced = true

export const state = {
  bankAccounts: [],
  tarfinProBankAccounts: []
}

export const mutations = {
  SET_BANK_ACCOUNTS(state, bankAccounts) {
    state.bankAccounts = bankAccounts
  },
  SET_TARFIN_PRO_BANK_ACCOUNTS(state, tarfinProBankAccounts) {
    state.tarfinProBankAccounts = tarfinProBankAccounts
  }
}

export const actions = {
  getBankAccounts({ commit }) {
    return new Promise(resolve => {
      BankAccountService.getBankAccounts().then(response => {
        commit('SET_BANK_ACCOUNTS', response.data)
        resolve(response.data)
      })
    })
  },
  getTarfinProBankAccounts({ commit }) {
    return new Promise(resolve => {
      BankAccountService.getTarfinProBankAccounts().then(response => {
        commit('SET_TARFIN_PRO_BANK_ACCOUNTS', response.data)
        resolve(response.data)
      })
    })
  }
}
